import { Stack } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

const AmendmentCardLabelText = ({ label, text }: { label: string; text?: string }) => {
  return (
    <Stack gap="xs">
      <TextWrapper fw={600} c="gray.6">
        {label}
      </TextWrapper>
      <TextWrapper fw={400}>{text}</TextWrapper>
    </Stack>
  );
};

export default AmendmentCardLabelText;
